/* import __COLOCATED_TEMPLATE__ from './chart-bar-with-tooltips.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();